import { render, staticRenderFns } from "./EnvironmentContainer.vue?vue&type=template&id=5de54a2c&"
import script from "./EnvironmentContainer.vue?vue&type=script&lang=js&"
export * from "./EnvironmentContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports